import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function preFooter() {
  return (
    <section className="prefooter-section section-padding">
      <Container fluid>
        <div class="row d-flex justify-content-center">
          <div class="col-lg-2 col-md-6 mb-4">
            <div className="prefooter-list text-center text-white">
              <div className="product-item">
                <Link to="/stories/" className="">
                  <StaticImage
                    className="img-fluid mb-3"
                    width={120}
                    height={100}
                    src="../../images/our-story.png"
                    alt="Our Story"
                  />
                  <h3 className="font-weight-bold mb-3">Our Story</h3>
                </Link>
                <p className="mb-4">
                  We want to bend history in the right direction.
                </p>
                <Link to="/stories/" className="cta-2 text-uppercase ">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 mb-4">
            <div className="prefooter-list text-center text-white">
              <div className="product-item">
                <Link to="/rally/" className="">
                  <StaticImage
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    src="../../images/our-rally.png"
                    alt="Our Rally"
                  />
                  <h3 className="font-weight-bold mb-3">Our Rally</h3>
                </Link>
                <p className="mb-4">
                  The FLUO
                  <br />
                  Revolution
                  <br /> has begun.
                </p>
                <Link to="/rally/" className="cta-2 text-uppercase ">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 mb-4">
            <div className="prefooter-list text-center text-white">
              <div className="product-item">
                <Link to="/belief/" className="">
                  <StaticImage
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    src="../../images/our-beliefs.png"
                    alt="Our Beliefs"
                  />
                  <h3 className="font-weight-bold mb-3">Our Beliefs</h3>
                </Link>
                <p className="mb-4">
                  Discover the Art of Living. Know freedom. Feel Alive
                  <sup>®</sup>.
                </p>
                <Link to="/belief/" className="cta-2 text-uppercase ">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 mb-4">
            <div className="prefooter-list text-center text-white">
              <div className="product-item">
                <Link to="/why-fluo/" className="">
                  <StaticImage
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    src="../../images/our-youth.png"
                    alt="Our Youth"
                  />
                  <h3 className="font-weight-bold mb-3">Our Youth</h3>
                </Link>
                <p className="mb-4">
                  Discover the FLUO Foundation, a youth mental health nonprofit.
                </p>
                <Link to="/why-fluo/" className="cta-2 text-uppercase ">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 mb-4">
            <div className="prefooter-list text-center text-white">
              <div className="product-item">
                <Link to="/stewardship/" className="">
                  <StaticImage
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    src="../../images/our-ways.png"
                    alt="Our Ways"
                  />
                  <h3 className="font-weight-bold mb-3">Our Ways</h3>
                </Link>
                <p className="mb-4">
                  Consciousness
                  <br />&<br /> Stewardship
                </p>
                <Link to="/stewardship/" className="cta-2 text-uppercase ">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
